import React from 'react';
import { Container, Heading, Text, Box, Stack, Flex } from '@chakra-ui/react';

const STEPS = [
  {
    title: 'Create Profile',
    text:
      'Profile section has various fields to describe yourself. feel free to update it more creatively as you wish.',
  },
  {
    title: 'Attend Event',
    text:
      'Every Event has Detail page to show attendes. Register yourself to event by clicking toggle button on the top of the page.',
  },
  {
    title: 'Discover People',
    text:
      'Now Discover new people who are attending same event. Just say hi to them by clicking message button.',
  },
];

const ThreeSteps = () => {
  return (
    <Box>
      <Container maxW={'7xl'} py={{ base: 10, sm: 20, md: 32 }}>
        <Heading as={'h3'} textAlign={'center'} mb={{ base: 14, sm: 16 }}>
          Just started in 3 easy steps
        </Heading>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify={'space-between'}
          align={{ base: 'center', md: 'flex-start' }}
        >
          {STEPS.map((step, index) => (
            <Stack
              textAlign={{ base: 'left', md: 'center' }}
              align={{ base: 'flex-start', md: 'center' }}
              spacing={4}
              key={step.title}
              maxW={{ base: 'full', md: 'xs' }}
              mt={{ base: 10, md: 0 }}
              _first={{
                mt: 0,
              }}
              px={4}
            >
              <Flex
                w={10}
                h={10}
                bg={'red.100'}
                color={'red.700'}
                fontWeight={700}
                align={'center'}
                justify={'center'}
                fontSize={'sm'}
                rounded={'md'}
              >
                0{index + 1}
              </Flex>
              <Text fontFamily={'heading'} fontSize={'xl'} color={'gray.700'}>
                {step.title}
              </Text>
              <Text color={'gray.500'}>{step.text}</Text>
            </Stack>
          ))}
        </Flex>
      </Container>
    </Box>
  );
};

export default ThreeSteps;
